module.exports = __webpack_public_path__ + "static/img/banner4.d018d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner4.png
// module id = 9dHY
// module chunks = 52